import { ClientPayloadType, DocumentationPayloadType, PayloadType } from '../types/general';

const reactAppVersion = process.env.REACT_APP_VERSION;

export const getClientPayloadType = (location: string): ClientPayloadType => {
  if (reactAppVersion === 'fhbf' && location.includes('fachberatungsstelle')) {
    return 'bs_client';
  }
  if (reactAppVersion === 'fhbf' && location.includes('interventionsstelle')) {
    return 'iste_client';
  }
  return 'client';
};

export const getDocumentationPayloadType = (location: string): DocumentationPayloadType => {
  if (reactAppVersion === 'fhbf' && location.includes('fachberatungsstelle')) {
    return 'bs_documentation';
  }
  if (reactAppVersion === 'fhbf' && location.includes('interventionsstelle')) {
    return 'iste_documentation';
  }
  return 'documentation';
};
